export const detailRoutes = {
    "/matchedReferral": {
        title: "Referral",
    },
    "/ppq": {
        title: "PPQ",
    },
    "/genericCaseForm": {
        title: "Generic Case",
    },
    "/matchedPhysiotherapyReferral": {
        title: "Physiotherapy Referral",
    },
    "/documents": {
        title: "Documents",
    },
    "/conversation": {
        title: "Conversation"
    }
};
